import React from 'react';
import { NavLink, Link } from 'react-router-dom';

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: '📊', exact: true },
  { path: '/admin/leaderboard', label: 'Leaderboard', icon: '🏆' },
  { path: '/admin/questions', label: 'Questions', icon: '❓' },
  { path: '/admin/testcases', label: 'Test Cases', icon: '🧪' },
  { path: '/admin/users', label: 'Users', icon: '👥' },
  { path: '/admin/submissions', label: 'Submissions', icon: '📝' },
  { path: '/admin/mappings', label: 'Progress', icon: '📈' },
  { path: '/admin/retry-requests', label: 'Retry Requests', icon: '🔄' },
  { path: '/admin/feedbacks', label: 'User Feedback', icon: '💬' },
  { path: '/admin/categories', label: 'Categories', icon: '🏷️' },
  { path: '/admin/dryrun', label: 'Dry Run', icon: '🔬' },
  { path: '/admin/import', label: 'Bulk Import', icon: '📦' },
];

const superAdminItems = [
  { path: '/admin/super-settings', label: 'Data Management', icon: '⚠️' },
];

function AdminSidebar({ isSuperAdmin = false }) {
  return (
    <aside className="w-64 bg-gray-800 border-r border-gray-700 min-h-screen">
      <div className="p-4 border-b border-gray-700">
        <h1 className="text-xl font-bold text-white">Admin Panel</h1>
        <p className="text-sm text-gray-400">Jurassic World</p>
      </div>

      <nav className="p-2">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.exact}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg mb-1 transition-colors ${
                isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700 hover:text-white'
              }`
            }
          >
            <span className="text-lg">{item.icon}</span>
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}

        {/* Super Admin Section */}
        {isSuperAdmin && (
          <>
            <div className="border-t border-gray-700 my-3" />
            <div className="px-4 py-2 text-xs text-red-400 uppercase tracking-wider font-semibold">
              Super Admin
            </div>
            {superAdminItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-lg mb-1 transition-colors ${
                    isActive
                      ? 'bg-red-600 text-white'
                      : 'text-red-300 hover:bg-red-900/30 hover:text-red-200'
                  }`
                }
              >
                <span className="text-lg">{item.icon}</span>
                <span className="font-medium">{item.label}</span>
              </NavLink>
            ))}
          </>
        )}
      </nav>

      <div className="absolute bottom-0 left-0 w-64 p-4 border-t border-gray-700">
        <Link
          to="/"
          className="flex items-center gap-3 px-4 py-2 text-gray-400 hover:text-white transition-colors"
        >
          <span>←</span>
          <span>Back to Game</span>
        </Link>
      </div>
    </aside>
  );
}

export default AdminSidebar;
